import React, { useEffect, useState, useMemo } from "react";
import { ArrowRight, Check, Sparkles, Heart, Star, Sun, Zap, Target, User, Users, ChevronDown, Play } from "lucide-react";
import "./EcolePromo.css";

const G = "https://gillesdelieuze.com/wp-content/uploads";

const IMG = {
    heroDauphins: `${G}/2025/03/gilles1385_dolphins_joy_happiness_neon_stellar_furist_ultra_det_d108e6d0-77b9-454e-9100-27fcbd17df2c-650x650.png`,
    chakras: `${G}/2025/02/gilles1385_figurative_futurist_photo_human_body_with_chakras_li_f3b9c26d-4156-4461-aafe-d50d95afe9b1.png`,
    paix: `${G}/2025/02/gilles1385_figurative_futurist_photo_of_woman_exprimant_la_paix_2193e425-c0b7-4671-913e-62e57f8d4064.png`,
    powerful: `${G}/2025/05/gilles1385_Ultra-realistic_photo_of_a_powerful_woman_standing_i_f5941fa6-62e2-491f-b2bc-e1b9e6742aa6.png`,
    renaissance: `${G}/2024/11/gilles1385_renaissance_new_age_galactic_divine_white_gold_multi_7abf6662-243e-4ba3-95d7-b78d395cf370.png`,
    avatar: `${G}/2023/07/gilles_divinite_divine_gold_ascension_avatar_ai_mythos_mystic_Q_90fc83b3-63ab-499d-9605-015536818f16.png`,
    dauphinLumineux: `${G}/2025/02/gilles1385_an_anime_style_and_luminous_dolphin_is_glowing_green_f8912b72-a338-40aa-a4cb-75effd9294b7-574x1024.png`,
    soin: `${G}/2024/11/gilles1385_soin_energetique_initiation_avec_les_dauphins_multid_dbedaed2-4935-4298-9aa6-7f5d969c568c-650x650.png`,
    bonus1: `${G}/2024/11/gilles1385_renaissance_new_age_galactic_divine_white_gold_multi_7abf6662-243e-4ba3-95d7-b78d395cf370.png`,
    bonus2: `${G}/2024/08/gilles1385_photo_art_ultrarealiste_Manta_ray_8K_cosmic_electric_cf2f4728-073c-4bc5-8622-ea475fb68dac.png`,
    bonus3: `${G}/2024/04/DALL%C2%B7E-2024-05-07-16.23.02-Create-a-high-resolution-digital-artwork-depicting-the-concept-of-equanimous-presence-with-enhancements.-The-image-should-feature-a-central-serene-fi.webp`,
    gilles: `${G}/2022/10/Gilles-2a-650x650.jpg`,
    gillesLast: `${G}/2022/12/Gilles-20c-1024x683.jpg`,
    meditationCristal: `${G}/2024/08/gilles1385_12_humains_qui_medites_avec_des_dauphins_de_cristal__21acedb8-2c3b-425f-80ee-927aebe800ab-650x650.png`,
    satisfait: `${G}/2024/03/satisfait-1024x1024.png`,
};

const MODULES = [
    { num: 1, color: "Dauphin rouge", name: "Kalim", title: "Libération des mémoires transgénérationnelles", img: `${G}/2024/09/gilles1385_red_galactic_Dolphin_cosmos_energy_divine_futuriste__757316d6-f200-40bb-b0ad-96096234844e.png` },
    { num: 2, color: "Dauphin orange", name: "Shampa Takir", title: "Le déblocage de ton plein potentiel", img: `${G}/2024/09/gilles1385_dauphin_orange_Dolphin_animal_on_first_plan_and_back_09df74af-0066-4a87-80af-166eada9dd41.png` },
    { num: 3, color: "Dauphin jaune", name: "Ra Limpaga", title: "La pacification des colères", img: `${G}/2024/10/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_Yellow_d_70b3a3e7-b643-4643-ab82-3f3056bdcdee.png` },
    { num: 4, color: "Dauphin vert", name: "Étoile Atlante", title: "Renforcer corps et mental par la respiration", img: `${G}/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_green_da_a98140e4-6ba3-4494-9961-363df18719aa.png` },
    { num: 5, color: "Dauphin rose", name: "Shanella", title: "La guérison d'une blessure d'amour", img: `${G}/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_rose_dau_74da70fd-fc44-4eb5-bc3a-2248cc164c13.png` },
    { num: 6, color: "Dauphin turquoise", name: "Logacy", title: "La joie de ton enfant intérieur", img: `${G}/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_turquois_8cbec288-5125-4e13-8bab-c1d122dcb180.png` },
    { num: 7, color: "Dauphin bleu", name: "Extensia", title: "Communication fluide & relations épanouies", img: `${G}/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_bleu_dau_2f1f455b-76ac-4c23-9567-ce8bc76c7c2e.png` },
    { num: 8, color: "Dauphin indigo", name: "Ajna activateur", title: "Activation de ta clairvoyance", img: `${G}/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_indigo_d_51c6ca3d-1191-436e-be4a-41912420509f.png` },
    { num: 9, color: "Dauphin violet", name: "Galimpanem", title: "Traverser une transition sereinement", img: `${G}/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_violet_d_1528da77-503d-4b09-932a-c40dc1dccfaf.png` },
    { num: 10, color: "Dauphin blanc", name: "Sky light", title: "La découverte de ta mission d'âme", img: `${G}/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_white_da_a42dc523-fa81-4471-80c2-b289b761bab4.png` },
    { num: 11, color: "Dauphin arc-en-ciel", name: "Rainbow light", title: "Transmutation de tes ombres en lumière", img: `${G}/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_rainbow__7d49a903-744c-4b40-b335-7a3073a0f6fa.png` },
    { num: 12, color: "Dauphin argent", name: "Silver light", title: "Libération de tous tes blocages", img: `${G}/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_silver_d_738f26d2-3620-4dec-930a-723f453e057d.png` },
    { num: 13, color: "Dauphin or", name: "Elashim", title: "Harmonisation de tes 12 chakras", img: `${G}/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_gold_dau_2af41b4c-93fa-4a0d-9f7b-d6944c5572d4.png` },
    { num: 14, color: "Dauphin diamant", name: "Diamant", title: "Alignement corps, esprit et âme", img: `${G}/2024/11/gilles1385_photo_futuriste_figuratif_Dolphin_Celestial_diamond__568ffd55-e58d-4455-b34f-975c4493bf84.png` },
];

const CLASSIQUE = [
    { x: "1x", label: "Paiement unique", reduc: "-30%", from: "2222€", to: "1555€", per: null },
    { x: "2x", label: "2 mensualités", reduc: "-25%", from: "2222€", to: "1667€", per: "834€/mois" },
    { x: "3x", label: "3 mensualités", reduc: "-20%", from: "2222€", to: "1778€", per: "593€/mois" },
    { x: "5x", label: "5 mensualités", reduc: "-20%", from: "2222€", to: "1778€", per: "356€/mois" },
    { x: "10x", label: "10 mensualités", reduc: "-18%", from: "2222€", to: "1822€", per: "182€/mois" },
    { x: "12x", label: "12 mensualités", reduc: "-15%", from: "2222€", to: "1889€", per: "157€/mois" },
    { x: "16x", label: "16 mensualités", reduc: "-10%", from: "2222€", to: "2000€", per: "125€/mois" },
];

const VIP = [
    { x: "1x", label: "Paiement unique", reduc: "-30%", from: "3333€", to: "2333€", per: null },
    { x: "2x", label: "2 mensualités", reduc: "-25%", from: "3333€", to: "2500€", per: "1250€/mois" },
    { x: "3x", label: "3 mensualités", reduc: "-20%", from: "3333€", to: "2666€", per: "889€/mois" },
];

const FAQ = [
    { q: "\"J'ai déjà fait plein de trucs.\"", a: "Parfait. Ici, tu ne viens pas ajouter une couche. Tu viens changer le niveau d'accès : état → intégration → stabilisation." },
    { q: "\"Je n'ai pas le temps.\"", a: "Tu n'as pas besoin de 2 heures par jour. Tu as besoin d'un réglage régulier qui te remet dans l'axe. Et avec l'accès à vie, tu peux avancer à ton rythme et y revenir au besoin." },
    { q: "\"Et si je retombe ?\"", a: "C'est précisément pour ça qu'il y a intégration + stabilisation. Pas juste un déclic. Un nouveau normal." },
    { q: "\"Et si je ne me sens pas prêt(e) ?\"", a: "La vraie question : combien de temps tu veux encore vivre en dessous de ce qui t'appelle ?" },
    { q: "\"J'ai peur d'être trop sensible.\"", a: "Ici, on ne t'excite pas : on te stabilise. On ne te pousse pas : on te calibre." },
    { q: "Je n'ai pas beaucoup de ressentis, est-ce que cela va fonctionner sur moi ?", a: "Bien sûr ! Mais je ne vais pas te mentir, ces énergies sont subtiles. Alors au début, tu auras peut-être l'impression que rien ne se passe. Mais tu vas constater que ton humeur change, ta façon de penser et d'agir se modifient. Très vite, tu vas ressentir l'énergie des dauphins qui t'accompagne au quotidien." },
    { q: "Je débute en spiritualité, est-ce que je peux m'inscrire ?", a: "Bien sûr ! Cette formation est conçue pour t'accompagner où que tu en sois dans ton cheminement spirituel. Le chemin est progressif, tu peux avancer à ton rythme et prendre tout le temps nécessaire pour intégrer ces puissantes énergies." },
    { q: "Je suis thérapeute, en quoi les maîtres dauphins peuvent-ils m'être utiles dans ma pratique ?", a: "De nombreux·ses thérapeutes choisissent de rejoindre l'École des Maîtres Dauphins pour aller plus loin dans leur pratique. Ils s'initient à la sagesse des Maîtres Dauphins pour enrichir leur pratique et apporter des solutions uniques et innovantes à leurs client·es." },
    { q: "Des fréquences dauphins, c'est pas un peu \"perché\" cette histoire ?", a: "Je ne te le fais pas dire ! J'ai été le premier à être surpris lorsque j'ai reçu ces transmissions delphiques par canalisation. J'étais plutôt cartésien avec mon parcours de juriste spécialisé en criminologie et droit pénal. Mais quand j'ai fait confiance et que j'ai vu à quel point les Maîtres dauphins ont transformé ma vie… J'ai accepté de ne pas tout savoir et de ne pas tout comprendre !" },
    { q: "J'ai déjà essayé beaucoup de choses. En quoi l'école est différente ?", a: "Avec les fréquences des maîtres dauphins, tu vas entrer dans un tout autre niveau de conscience : celui du monde quantique. Ces fréquences envoient de puissants codes dans tes cellules et l'eau dont ton corps est composé à 60%. Le vrai plus de cette méthode, c'est qu'à chaque module tu effectues un soin d'intégration qui permet à cette nouvelle énergie de s'ancrer en toi durablement." },
    { q: "Quelle est la garantie satisfait ou remboursé ?", a: "Tu as 14 jours pour faire le test et découvrir le module 1, dans la limite de l'ouverture du Module 1. Si cela ne correspond pas à tes attentes : remboursement intégral." },
];

const TESTIMONIALS = [
    { text: "Je croyais avoir perdu ma joie depuis longtemps… mais dès la première immersion avec Gilles et l'énergie des dauphins, j'ai senti un souffle nouveau. J'ai recommencé à rire sans raison, comme une enfant.", name: "Claire - 42 ans", role: "Professeure des écoles" },
    { text: "J'accompagne déjà des patients, mais je n'avais jamais ressenti une telle puissance dans mes soins. J'ai intégré un souffle de légèreté et mes clients l'ont immédiatement perçu.", name: "Daniel - 35 ans", role: "Thérapeute Holistique" },
    { text: "J'étais épuisée, perdue dans mes choix de vie. Cette école m'a reconnectée à une joie simple et profonde. Je me sens à nouveau vivante et confiante dans mon chemin.", name: "Mélanie - 28 ans", role: "Doctorante en Psychologie" },
];

const BDC = "https://gillesdelieuze.com/bdc-ecole-maitres-dauphins/";
const RDV = "https://gillesdelieuze.com/rdv-clarte-2/";

const useReveal = () => {
    useEffect(() => {
        const observer = new IntersectionObserver(
            entries => entries.forEach(e => {
                if (e.isIntersecting) {
                    e.target.classList.add("in");
                    observer.unobserve(e.target);
                }
            }),
            { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
        );
        document.querySelectorAll(".reveal, .reveal-scale, .reveal-slide-left, .reveal-slide-right").forEach(el => observer.observe(el));
        return () => observer.disconnect();
    }, []);
};

// Random animated particles + stars (memoized so they don't re-shuffle on re-render)
const CosmicBackground = () => {
    const particles = useMemo(() => {
        return Array.from({ length: 40 }, (_, i) => ({
            id: i,
            color: ["gold", "blue", "violet"][i % 3],
            size: 2 + Math.random() * 6,
            left: Math.random() * 100,
            duration: 15 + Math.random() * 20,
            delay: Math.random() * 30,
        }));
    }, []);
    const stars = useMemo(() => {
        return Array.from({ length: 35 }, (_, i) => ({
            id: i,
            size: 1.5 + Math.random() * 1.5,
            left: Math.random() * 100,
            top: Math.random() * 100,
            delay: Math.random() * 3,
        }));
    }, []);
    return (
        <>
            <div className="absolute inset-0 pointer-events-none overflow-hidden">
                {stars.map(s => (
                    <div
                        key={`star-${s.id}`}
                        className="star"
                        style={{
                            width: `${s.size}px`, height: `${s.size}px`,
                            left: `${s.left}%`, top: `${s.top}%`,
                            animationDelay: `${s.delay}s`,
                        }}
                    />
                ))}
                {particles.map(p => (
                    <div
                        key={`p-${p.id}`}
                        className={`particle particle-${p.color}`}
                        style={{
                            width: `${p.size}px`, height: `${p.size}px`,
                            left: `${p.left}%`, bottom: "-5%",
                            animationDuration: `${p.duration}s`,
                            animationDelay: `${p.delay}s`,
                        }}
                    />
                ))}
            </div>
            <div className="absolute inset-0 bg-stellar pointer-events-none" />
            <div className="absolute inset-0 bg-cosmic pointer-events-none" />
        </>
    );
};

const SectionTitle = ({ eyebrow, children }) => (
    <div className="text-center max-w-4xl mx-auto mb-14 md:mb-20">
        {eyebrow && <p className="mono mb-5 reveal">{eyebrow}</p>}
        <h2 className="ecole-h2 serif text-3xl sm:text-4xl md:text-5xl text-foreground leading-[1.08] reveal reveal-delay-1">{children}</h2>
        <div className="divider-gold w-32 mx-auto my-8 reveal reveal-delay-2" />
    </div>
);

const PriceRow = ({ p }) => (
    <div className="flex items-center justify-between border-b border-[var(--border)] py-3 last:border-0">
        <div>
            <span className="mono mr-3" style={{ fontSize: "0.78rem" }}>{p.x}</span>
            <span className="text-sm md:text-base text-foreground-soft">{p.label}</span>
        </div>
        <div className="text-right">
            <span className="mono mr-2" style={{ fontSize: "0.7rem" }}>{p.reduc}</span>
            <span className="text-muted line-through text-xs mr-2">{p.from}</span>
            <span className="text-foreground font-bold text-base md:text-lg">{p.to}</span>
            {p.per && <p className="text-xs text-muted mt-0.5">soit {p.per}</p>}
        </div>
    </div>
);

const EcolePromo = () => {
    const [openFaq, setOpenFaq] = useState(null);
    useReveal();

    useEffect(() => {
        document.title = "École des Maîtres Dauphins · Gilles Delieuze";
        window.scrollTo(0, 0);
    }, []);

    // Duplicate modules for seamless marquee loop
    const marqueeModules = [...MODULES, ...MODULES];

    return (
        <main className="ecole-page min-h-screen overflow-x-hidden" translate="no">

            <div className="ecole-promo-banner">
                ✨  OFFRE SPÉCIALE · JUSQU'À -30% · PROMO 7 JOURS  ✨
            </div>

            {/* HERO */}
            <section className="ecole-section relative bg-hero-gradient overflow-hidden section-padding pt-16 md:pt-24">
                <CosmicBackground />
                <div className="container-luxury relative z-10">
                    <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
                        <div className="text-center lg:text-left">
                            <div className="hero-fade hero-fade-1 mb-7 inline-block">
                                <span className="ecole-pill pulse-glow"><Sparkles className="w-4 h-4" /> JUSQU'À -30% · OFFRE LIMITÉE</span>
                            </div>
                            <p className="mono text-gold-luminous mb-4 hero-fade hero-fade-2 block">PLONGE DANS</p>
                            <h1 className="ecole-h1 serif text-[2.6rem] sm:text-5xl md:text-6xl lg:text-7xl text-foreground leading-[0.98] mb-6 hero-fade hero-fade-3">
                                L'École des<br />
                                <span className="block text-gradient-gold-shine text-glow-gold">Maîtres Dauphins</span>
                            </h1>
                            <p className="ecole-body-lg text-base md:text-xl text-foreground-soft leading-relaxed mt-6 mb-8 max-w-xl mx-auto lg:mx-0 hero-fade hero-fade-4">
                                Un chemin pour vibrer plus fort, aimer ta vie… et, si tu le choisis, transmettre cette fréquence.
                            </p>
                            <div className="space-y-3 mb-10 hero-fade hero-fade-4">
                                <div className="flex items-center gap-3 text-foreground-soft text-base md:text-lg justify-center lg:justify-start">
                                    <span className="w-2 h-2 rounded-full bg-accent shadow-gold shrink-0" />
                                    <span>Pour toi qui veux retrouver la joie, la fluidité et le sens.</span>
                                </div>
                                <div className="flex items-center gap-3 text-foreground-soft text-base md:text-lg justify-center lg:justify-start">
                                    <span className="w-2 h-2 rounded-full bg-accent shadow-gold shrink-0" />
                                    <span>Pour toi qui veux accompagner avec intégrité et puissance.</span>
                                </div>
                            </div>
                            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start hero-fade hero-fade-5">
                                <a href={BDC} target="_blank" rel="noopener noreferrer" className="btn-gold">
                                    Je réserve ma place maintenant <ArrowRight className="w-5 h-5" />
                                </a>
                                <a href={RDV} target="_blank" rel="noopener noreferrer" className="btn-outline-gold">
                                    <Play className="w-5 h-5" /> RDV Clarté
                                </a>
                            </div>
                        </div>

                        <div className="relative reveal-scale">
                            <div className="relative aspect-square max-w-lg mx-auto">
                                <div className="absolute inset-0 rounded-full bg-accent/25 blur-3xl" />
                                <div className="relative rounded-3xl overflow-hidden border border-accent/30 shadow-gold-intense">
                                    <img src={IMG.heroDauphins} alt="Dauphins cosmiques" className="w-full h-full object-cover" />
                                    <div className="absolute inset-0 bg-gradient-to-t from-[var(--bg)]/60 via-transparent to-transparent" />
                                </div>
                                <div className="absolute -top-6 -right-6 w-24 h-24 rounded-2xl glass-gold flex items-center justify-center shadow-gold">
                                    <span className="serif text-3xl text-gradient-gold font-light">14</span>
                                    <span className="text-xs text-accent ml-1">fréquences</span>
                                </div>
                                <div className="absolute -bottom-4 -left-4 px-6 py-3 rounded-full glass-card">
                                    <span className="text-sm text-foreground">✨ +500 membres transformés</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* PILIERS */}
            <section className="ecole-section section-padding bg-bg-main relative overflow-hidden">
                <CosmicBackground />
                <div className="container-luxury relative">
                    <SectionTitle eyebrow="UN PORTAIL DE TRANSFORMATION">
                        Un portail pour changer de timeline<br />
                        <span className="text-gradient-gold-shine">et te déployer</span>
                    </SectionTitle>
                    <p className="ecole-body-md text-center text-base md:text-xl text-foreground-soft max-w-2xl mx-auto mb-12 reveal">
                        Un voyage d'expansion de conscience pour retrouver une vie remplie d'amour, de joie et de légèreté !
                    </p>
                    <h3 className="text-center serif text-xl md:text-2xl text-foreground mb-12 reveal">Active la sagesse des Maîtres Dauphins pour :</h3>
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
                        {[
                            { icon: Heart, title: "SOIN", desc: "Te libérer de tes blessures de vie, karmiques et transgénérationnelles." },
                            { icon: Sparkles, title: "RÉVÉLATION", desc: "Révéler les trésors cachés de ta personnalité (ce pour quoi tu t'es incarné·e)" },
                            { icon: Sun, title: "RAYONNEMENT", desc: "Oser être visible et prendre ta place (sans peur du jugement)" },
                            { icon: Zap, title: "POTENTIELS", desc: "Réveiller les pouvoirs énergétiques et psychiques qui dorment en toi" },
                            { icon: Target, title: "MISSION", desc: "Devenir praticien en soins quantiques" },
                        ].map(({ icon: Icon, title, desc }, i) => (
                            <div key={title} className={`luxury-card-gold p-7 md:p-8 reveal reveal-delay-${(i % 5) + 1}`}>
                                <div className="w-14 h-14 rounded-xl bg-accent/10 flex items-center justify-center mb-5">
                                    <Icon className="w-7 h-7 text-accent" />
                                </div>
                                <h3 className="serif text-xl text-foreground mb-3">{title}</h3>
                                <p className="text-sm md:text-base text-foreground-soft leading-relaxed">{desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* POUR QUI */}
            <section className="ecole-section section-padding bg-bg-secondary relative overflow-hidden">
                <div className="absolute inset-0 bg-stellar pointer-events-none" />
                <div className="container-luxury relative">
                    <div className="grid lg:grid-cols-2 gap-8 mb-16">
                        <div className="luxury-card p-8 md:p-10 reveal-slide-left">
                            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-accent to-transparent opacity-60" />
                            <div className="flex items-center gap-4 mb-6">
                                <div className="w-12 h-12 rounded-xl bg-accent/10 flex items-center justify-center shadow-gold">
                                    <User className="w-6 h-6 text-accent" />
                                </div>
                                <h3 className="serif text-2xl md:text-3xl text-foreground">Pour Toi</h3>
                            </div>
                            <ul className="space-y-4">
                                {["Retrouve la joie de vivre", "Libérer tes blocages intérieurs", "Reconnecte ton corps et ton âme", "Kiffe ta vie, pleinement incarné(e)"].map(t => (
                                    <li key={t} className="flex items-center gap-3 text-foreground-soft text-base md:text-lg">
                                        <span className="w-6 h-6 rounded-full bg-accent/20 flex items-center justify-center shrink-0">
                                            <Check className="w-4 h-4 text-accent" />
                                        </span>{t}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="luxury-card-gold p-8 md:p-10 reveal-slide-right">
                            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-accent-light to-transparent" />
                            <div className="flex items-center gap-4 mb-6">
                                <div className="w-12 h-12 rounded-xl bg-accent/20 flex items-center justify-center shadow-gold">
                                    <Users className="w-6 h-6 text-accent" />
                                </div>
                                <h3 className="serif text-2xl md:text-3xl text-foreground">Pour les Praticiens</h3>
                            </div>
                            <ul className="space-y-4 mb-8">
                                {["Intègre des outils vibratoires uniques", "Donne des soins profonds et éthiques", "Déploie ta puissance lumineuse", "Transforme tes accompagnements"].map(t => (
                                    <li key={t} className="flex items-center gap-3 text-foreground-soft text-base md:text-lg">
                                        <span className="w-6 h-6 rounded-full bg-accent/30 flex items-center justify-center shrink-0">
                                            <Check className="w-4 h-4 text-accent" />
                                        </span>{t}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    <div className="max-w-4xl mx-auto reveal">
                        <div className="glass-card p-8 md:p-12 mb-12">
                            <p className="ecole-body-lg serif text-xl md:text-3xl text-foreground leading-relaxed mb-6">
                                <span className="text-gradient-gold">Tu as tout pour être heureux(se) sur le papier…</span> mais ça ne vibre pas autant que prévu.
                            </p>
                            <p className="ecole-body-md text-foreground-soft text-base md:text-lg leading-relaxed mb-4">Ici, on ne te sert pas des concepts prémâchés.</p>
                            <p className="ecole-body-md text-foreground text-base md:text-lg leading-relaxed">
                                On est sur du <span className="text-gold-luminous font-semibold">high level</span> : précis, profond, incarné. Une forme de <span className="text-gold-luminous font-semibold">haute couture intérieure</span>.
                            </p>
                        </div>
                        <h3 className="serif text-2xl md:text-3xl lg:text-4xl text-foreground text-center mb-8">Cette École est pour toi si :</h3>
                        <div className="grid md:grid-cols-2 gap-4">
                            {[
                                "tu es fatigué(e) de \"comprendre\" sans que ta réalité suive",
                                "tu veux arrêter de te corriger et commencer à te déployer",
                                "tu veux une joie stable, pas un shoot d'inspiration",
                                "tu veux une spiritualité incarnée : corps, émotion, choix, présence",
                                "tu sens que tu es prêt(e) à changer de niveau (un vrai)",
                            ].map((t, i) => (
                                <div key={t} className={`flex items-start gap-4 p-5 rounded-xl glass-card reveal reveal-delay-${(i % 5) + 1}`}>
                                    <span className="w-8 h-8 rounded-full bg-accent/20 flex items-center justify-center shrink-0 mt-0.5">
                                        <Check className="w-4 h-4 text-accent" />
                                    </span>
                                    <p className="text-foreground-soft text-base md:text-lg leading-relaxed">{t}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* FRÉQUENCES VIBRATOIRES */}
            <section className="ecole-section section-padding bg-bg-main relative overflow-hidden">
                <CosmicBackground />
                <div className="container-luxury relative">
                    <SectionTitle eyebrow="FRÉQUENCES VIBRATOIRES">
                        De puissantes <span className="text-gradient-gold">fréquences vibratoires</span><br />
                        reçues par canalisation
                    </SectionTitle>
                    <p className="mono text-center text-gold-luminous mb-10 reveal">C'EST EN T'Y CONNECTANT QU'ELLES VONT TE PERMETTRE :</p>
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
                        {[
                            { img: IMG.chakras, title: "Ressentir que tu es enfin arrivé·e \"à la maison\"", desc: "Tu vas apprendre à vivre dans cet état de haute vibration au quotidien." },
                            { img: IMG.paix, title: "Retirer couches après couches ce qui t'empêche d'être heureux·se", desc: "Libéré·e des deuils, déceptions et traumatismes, tu te sentiras plus léger·e et confiant·e." },
                            { img: IMG.powerful, title: "Faire la paix avec le passé", desc: "Et toutes les émotions lourdes qui y sont associées. D'être présent·e à ce qui est." },
                            { img: IMG.renaissance, title: "Vivre dans un état de conscience supérieure", desc: "Tu vas apprendre à surfer la vie avec autant de fluidité qu'un dauphin." },
                            { img: IMG.avatar, title: "Développer tes capacités médiumniques", desc: "Clairvoyance, intuition, vision du futur. L'énergie des Maîtres Dauphins t'ouvrira ce portail." },
                            { img: IMG.dauphinLumineux, title: "Le mécanisme signature · CLOUD & TIMELINE", desc: "Tu te reconnectes à une version plus haute de toi… puis tu l'installes dans la matière." },
                        ].map((c, i) => (
                            <article key={i} className={`luxury-card overflow-hidden reveal-scale reveal-delay-${(i % 5) + 1}`}>
                                <div className="aspect-[4/3] overflow-hidden">
                                    <img src={c.img} alt={c.title} className="w-full h-full object-cover transition-transform duration-[1400ms] hover:scale-105" loading="lazy" />
                                </div>
                                <div className="p-6 md:p-7">
                                    <h4 className="serif text-xl md:text-2xl text-foreground leading-tight mb-3">{c.title}</h4>
                                    <p className="text-sm md:text-base text-foreground-soft leading-relaxed">{c.desc}</p>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </section>

            {/* 14 MODULES - MARQUEE */}
            <section className="ecole-section section-padding bg-bg-secondary relative overflow-hidden">
                <div className="absolute inset-0 bg-stellar pointer-events-none" />
                <div className="container-luxury relative mb-12">
                    <SectionTitle eyebrow="PHASE 1 · 14 MODULES">
                        Tu te transformes une fréquence après l'autre<br />
                        <span className="text-gradient-gold">grâce à de puissants codes quantiques</span>
                    </SectionTitle>
                    <p className="ecole-body-md text-center text-base md:text-xl text-foreground-soft max-w-3xl mx-auto mb-10 reveal">
                        14 sessions, chacune une fréquence delphique. Dans chaque module : méditation, intégration, mantra, géométrie sacrée et exercices pratiques.
                    </p>
                </div>

                <div className="modules-marquee-wrap reveal">
                    <div className="modules-marquee">
                        {marqueeModules.map((m, i) => (
                            <article key={`m-${i}`} className="module-card">
                                <div className="aspect-square overflow-hidden relative">
                                    <img src={m.img} alt={m.color} className="w-full h-full object-cover" loading="lazy" />
                                    <span className="absolute top-3 left-3 mono text-[10px] text-[#0A0E1E] bg-gradient-to-br from-[var(--accent-light)] to-[var(--accent)] rounded-full px-3 py-1.5 font-bold">Module {m.num}</span>
                                </div>
                                <div className="p-5">
                                    <p className="mono text-[10px] mb-2">{m.color} · {m.name}</p>
                                    <h4 className="serif text-lg md:text-xl text-foreground leading-tight">{m.title}</h4>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
                <p className="text-center text-muted text-xs mt-6">survole pour mettre en pause</p>
            </section>

            {/* PHASE 2 + BONUS */}
            <section className="ecole-section section-padding bg-bg-main relative overflow-hidden">
                <CosmicBackground />
                <div className="container-luxury relative">
                    <SectionTitle eyebrow="PHASE 2 · DEVENIR PRATICIEN">
                        Canaliser les fréquences vibratoires<br />
                        <span className="text-gradient-gold">pour faire des soins énergétiques</span>
                    </SectionTitle>
                    <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center mb-24">
                        <div className="reveal-slide-left">
                            <img src={IMG.soin} alt="Soins énergétiques" className="rounded-3xl w-full shadow-gold-intense border border-accent/20" loading="lazy" />
                        </div>
                        <ul className="space-y-6 reveal-slide-right">
                            {[
                                ["Rétablir l'harmonie énergétique", "Grâce à la technique d'étirement des filaments."],
                                ["Encoder des élixirs", "Comme les fleurs de Bach mais multidimensionnel."],
                                ["Soigner dans la joie et le jeu", "Le secret d'un soin énergétique réussi."],
                                ["Activer ta \"dolphin banane !\"", "Une technique de respiration qui active ton énergie vitale."],
                                ["Recevoir une guidance Maîtres Dauphins", "Grâce à l'oracle, recevoir des messages personnalisés."],
                            ].map(([t, d]) => (
                                <li key={t}>
                                    <p className="serif text-xl md:text-2xl text-foreground mb-1">{t}</p>
                                    <p className="text-sm md:text-base text-foreground-soft">{d}</p>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <SectionTitle eyebrow="ET CE N'EST PAS TOUT...">
                        <span className="text-gradient-gold">3 bonus exclusifs</span><br />
                        <span className="text-foreground-soft text-2xl md:text-3xl block mt-3">d'une valeur totale de 560€</span>
                    </SectionTitle>
                    <div className="grid md:grid-cols-3 gap-6 md:gap-7">
                        {[
                            { img: IMG.bonus1, val: "149€", num: "Bonus #1", title: "Le protocole chamanique des deuils et renaissances 🌓", desc: "Libère l'ancien pour accueillir le nouveau grâce à ce puissant protocole." },
                            { img: IMG.bonus2, val: "231€", num: "Bonus #2", title: "3 transmissions · Baleine, Béluga, Raie", desc: "Accède à des savoirs galactiques et comprends ta place dans le monde." },
                            { img: IMG.bonus3, val: "180€", num: "Bonus #3", title: "Sommet Métamorphose · oser prendre TA PLACE", desc: "5 clés pour suivre ta voix et 7 pépites pour lancer une activité alignée." },
                        ].map((b, i) => (
                            <article key={b.num} className={`luxury-card-gold overflow-hidden reveal-scale reveal-delay-${i + 1}`}>
                                <div className="aspect-[4/3] overflow-hidden relative">
                                    <img src={b.img} alt={b.title} className="w-full h-full object-cover" loading="lazy" />
                                    <span className="absolute top-3 right-3 mono text-[10px] text-[#0A0E1E] bg-gradient-to-br from-[var(--accent-light)] to-[var(--accent)] rounded-full px-3 py-1.5 font-bold">Valeur : {b.val}</span>
                                </div>
                                <div className="p-6 md:p-7">
                                    <p className="mono mb-2 text-[10px]">{b.num}</p>
                                    <h4 className="serif text-xl md:text-2xl text-foreground leading-tight mb-3">{b.title}</h4>
                                    <p className="text-sm md:text-base text-foreground-soft leading-relaxed">{b.desc}</p>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </section>

            {/* GILLES */}
            <section className="ecole-section section-padding bg-bg-secondary relative overflow-hidden">
                <div className="absolute inset-0 bg-stellar pointer-events-none" />
                <div className="container-luxury relative">
                    <div className="grid md:grid-cols-2 gap-10 md:gap-16 items-center max-w-5xl mx-auto">
                        <div className="relative aspect-[4/5] rounded-3xl overflow-hidden reveal-slide-left shadow-gold-intense border border-accent/20">
                            <img src={IMG.gilles} alt="Gilles Delieuze" className="w-full h-full object-cover" />
                        </div>
                        <div className="reveal-slide-right">
                            <p className="mono mb-4">QUI SUIS-JE</p>
                            <h2 className="ecole-h2 serif text-4xl md:text-5xl lg:text-6xl text-foreground mb-3">Gilles Delieuze</h2>
                            <p className="serif italic text-lg md:text-xl text-accent mb-7">Mentor · Auteur · Enseignant</p>
                            <p className="ecole-body-md text-base md:text-lg text-foreground-soft leading-relaxed mb-5">
                                Cela fait <strong className="text-accent">25 ans</strong> que j'accompagne des personnes en quête d'un mieux-être et 17 ans que je suis un expert Dauphins.
                            </p>
                            <p className="serif italic text-lg md:text-xl text-foreground mb-5">
                                "Je sais la souffrance que cela génère de ne pas se sentir à sa place. D'être bloqué dans des schémas répétitifs."
                            </p>
                            <p className="ecole-body-md text-base md:text-lg text-foreground-soft leading-relaxed">
                                En 2007, je reçois un "appel" mystique à 3h33. Une énergie se présente à moi sous le nom de "Maîtres Dauphins". Cet appel m'a permis de sortir la tête de l'eau.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* TARIFS */}
            <section id="tarifs" className="ecole-section section-padding bg-bg-main relative overflow-hidden">
                <CosmicBackground />
                <div className="container-luxury relative">
                    <div className="text-center mb-14 md:mb-16">
                        <span className="ecole-pill mb-5 reveal">⭐ OFFRE SPÉCIALE · PROMO 7 JOURS</span>
                        <h2 className="ecole-h2 serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-foreground mt-6 reveal reveal-delay-1">
                            L'investissement pour rejoindre<br />
                            <span className="text-gradient-gold-shine">l'École des Maîtres Dauphins</span>
                        </h2>
                        <p className="mono text-gold-luminous mt-7 reveal reveal-delay-2">JUSQU'À -30%</p>
                        <p className="ecole-body-md text-foreground-soft text-base md:text-lg mt-6 reveal reveal-delay-3">
                            Grille des réductions selon votre mode de paiement
                        </p>
                    </div>

                    <div className="grid md:grid-cols-2 gap-7 md:gap-9 max-w-6xl mx-auto">
                        {/* CLASSIQUE */}
                        <div className="price-frame p-7 md:p-10 reveal-scale">
                            <p className="mono mb-3">FORMULE CLASSIQUE</p>
                            <h3 className="serif text-2xl md:text-3xl text-foreground mb-3">École des Maîtres Dauphins</h3>
                            <span className="ecole-pill mb-5 inline-block">JUSQU'À -30%</span>
                            <p className="text-muted line-through text-base mb-1">2222€</p>
                            <p className="serif text-5xl md:text-6xl text-gradient-gold-shine mb-1 font-light">1555€</p>
                            <p className="text-sm text-muted mb-7">en 1x</p>
                            <p className="mono mb-4">OPTIONS DE PAIEMENT :</p>
                            <div className="mb-7">{CLASSIQUE.map(p => <PriceRow key={p.x} p={p} />)}</div>
                            <ul className="space-y-3 mb-8">
                                {["Formation complète avec accès illimité", "Modules de soins énergétiques", "5 fréquences bonus (Baleine, Béluga, Méduse, Hippocampe, Raie)", "Live Mensuel", "Bonus Dauphins hybrides", "Accès communauté active"].map(t => (
                                    <li key={t} className="flex gap-2.5 text-sm md:text-base text-foreground-soft">
                                        <Check className="w-4 h-4 text-accent shrink-0 mt-1" /><span>{t}</span>
                                    </li>
                                ))}
                            </ul>
                            <a href={BDC} target="_blank" rel="noopener noreferrer" className="btn-gold w-full justify-center" style={{ width: "100%" }}>
                                Je m'inscris <ArrowRight className="w-5 h-5" />
                            </a>
                        </div>

                        {/* VIP */}
                        <div className="price-frame p-7 md:p-10 relative reveal-scale reveal-delay-1">
                            <span className="absolute -top-3.5 right-7 ecole-pill pulse-glow text-[10px]">⭐ POPULAIRE</span>
                            <p className="mono mb-3">FORMULE VIP</p>
                            <h3 className="serif text-2xl md:text-3xl text-foreground mb-3">École des Maîtres + Mentorat 1to1</h3>
                            <span className="ecole-pill mb-5 inline-block">JUSQU'À -30%</span>
                            <p className="text-muted line-through text-base mb-1">3333€</p>
                            <p className="serif text-5xl md:text-6xl text-gradient-gold-shine mb-1 font-light">2333€</p>
                            <p className="text-sm text-muted mb-7">en 1x</p>
                            <p className="mono mb-4">OPTIONS DE PAIEMENT :</p>
                            <div className="mb-7">{VIP.map(p => <PriceRow key={p.x} p={p} />)}</div>
                            <ul className="space-y-3 mb-8">
                                {["Tout de la formule Classique", "Fil d'urgence prioritaire", "Mentorat et supervision 1to1 : 3 RDV d'1h30 avec Gilles"].map(t => (
                                    <li key={t} className="flex gap-2.5 text-sm md:text-base text-foreground-soft">
                                        <Check className="w-4 h-4 text-accent shrink-0 mt-1" /><span>{t}</span>
                                    </li>
                                ))}
                            </ul>
                            <a href={BDC} target="_blank" rel="noopener noreferrer" className="btn-gold w-full justify-center" style={{ width: "100%" }}>
                                Je choisis le cursus VIP <ArrowRight className="w-5 h-5" />
                            </a>
                        </div>
                    </div>

                    <div className="text-center mt-14 reveal">
                        <p className="ecole-body-md text-foreground-soft text-base md:text-lg mb-2">Tu hésites ?</p>
                        <p className="serif text-2xl md:text-3xl text-foreground mb-4">Réserve un RDV Clarté gratuit</p>
                        <p className="text-foreground-soft text-sm md:text-base mb-6">Un appel de 20 minutes avec Celia pour répondre à toutes tes questions.</p>
                        <a href={RDV} target="_blank" rel="noopener noreferrer" className="btn-outline-gold">Prendre RDV avec Celia</a>
                    </div>

                    {/* GARANTIE */}
                    <div className="mt-20 max-w-3xl mx-auto glass-card p-9 md:p-12 text-center reveal-scale">
                        <img src={IMG.satisfait} alt="Garantie satisfait ou remboursé" className="w-24 h-24 mx-auto mb-5 object-contain" />
                        <h3 className="serif text-2xl md:text-3xl lg:text-4xl text-foreground mb-5">
                            <span className="text-gradient-gold">0 risque</span> avec la garantie "satisfait·e ou remboursé·e"
                        </h3>
                        <p className="ecole-body-md text-base md:text-lg text-foreground-soft leading-relaxed">
                            Tu as <strong className="text-accent">14 jours</strong> pour faire le test et découvrir le module 1, <strong className="text-accent">dans la limite de l'ouverture du Module 1</strong>. Si cela ne correspond pas à tes attentes : remboursement intégral.
                        </p>
                    </div>
                </div>
            </section>

            {/* FAQ */}
            <section id="faq" className="ecole-section section-padding bg-bg-main relative overflow-hidden">
                <div className="absolute inset-0 bg-stellar pointer-events-none" />
                <div className="container-luxury relative">
                    <SectionTitle eyebrow="QUESTIONS FRÉQUENTES">
                        Tu as encore des questions ?<br />
                        <span className="text-gradient-gold">J'y réponds !</span>
                    </SectionTitle>
                    <div className="max-w-3xl mx-auto luxury-card p-6 md:p-10 reveal">
                        {FAQ.map((f, i) => (
                            <div key={i} className="faq-item" data-open={openFaq === i}>
                                <button
                                    onClick={() => setOpenFaq(openFaq === i ? null : i)}
                                    className="w-full py-6 flex items-start justify-between gap-4 text-left group"
                                >
                                    <span className="serif text-base md:text-xl text-foreground group-hover:text-accent transition-colors">{f.q}</span>
                                    <ChevronDown className="faq-chevron w-5 h-5 shrink-0 mt-1" />
                                </button>
                                <div className={`grid transition-all duration-500 ${openFaq === i ? "grid-rows-[1fr] opacity-100 pb-6" : "grid-rows-[0fr] opacity-0"}`}>
                                    <div className="overflow-hidden">
                                        <p className="text-foreground-soft text-sm md:text-base leading-relaxed">{f.a}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <p className="text-center text-foreground-soft mt-12 text-base md:text-lg reveal">
                        Tu as d'autres questions ?{" "}
                        <a href="mailto:gilles@centre-terre-ciel.com" className="text-accent hover:underline">gilles@centre-terre-ciel.com</a>
                    </p>
                </div>
            </section>

            {/* FINAL CTA */}
            <section className="ecole-section section-padding bg-bg-secondary relative overflow-hidden">
                <CosmicBackground />
                <div className="container-luxury relative">
                    <div className="max-w-4xl mx-auto mb-20 reveal">
                        <div className="relative rounded-3xl overflow-hidden">
                            <img src={IMG.meditationCristal} alt="Méditation avec les dauphins" className="w-full h-[400px] md:h-[500px] object-cover" loading="lazy" />
                            <div className="absolute inset-0 bg-gradient-to-t from-[var(--bg)] via-[var(--bg)]/80 to-[var(--bg)]/30" />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="text-center p-6 md:p-8">
                                    <h2 className="ecole-h2 serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-foreground leading-[1.08] mb-6">
                                        Les Maîtres Dauphins t'attendent.<br />
                                        <span className="block text-gradient-gold-shine text-glow-gold mt-2">Et si c'était maintenant ton grand plongeon ?</span>
                                    </h2>
                                    <a href={BDC} target="_blank" rel="noopener noreferrer" className="btn-gold mt-4">
                                        Je rejoins l'école <ArrowRight className="w-5 h-5" />
                                    </a>
                                    <div className="mt-7 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[var(--bg)]/60 backdrop-blur-sm border border-accent/30">
                                        <span className="text-gold-luminous text-sm">Essaie 14 Jours · Satisfait ou Remboursé · Dans la limite de l'ouverture du Module 1</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="grid md:grid-cols-3 gap-6 mb-16">
                        {TESTIMONIALS.map((t, i) => (
                            <blockquote key={t.name} className={`glass-card p-6 md:p-7 reveal reveal-delay-${i + 1}`}>
                                <div className="flex gap-1 mb-4">
                                    {[0, 1, 2, 3, 4].map(s => <Star key={s} className="w-4 h-4 fill-accent text-accent" />)}
                                </div>
                                <p className="text-foreground-soft text-sm md:text-base italic leading-relaxed mb-4">"{t.text}"</p>
                                <div className="border-t border-[var(--border)] pt-4">
                                    <p className="serif text-foreground text-base md:text-lg">{t.name}</p>
                                    <p className="text-xs md:text-sm text-muted">{t.role}</p>
                                </div>
                            </blockquote>
                        ))}
                    </div>

                    <div className="flex items-center justify-center gap-6 mb-12 reveal">
                        <img src={IMG.gillesLast} alt="Gilles Delieuze" className="w-20 h-20 rounded-full object-cover border-2 border-accent/30 shadow-gold" />
                        <div>
                            <p className="text-muted text-sm mb-1">By</p>
                            <p className="serif text-xl md:text-2xl text-foreground">Gilles Delieuze</p>
                        </div>
                    </div>

                    <div className="text-center reveal">
                        <h3 className="serif text-2xl md:text-3xl text-foreground mb-6">Il suffit d'un choix</h3>
                        <p className="text-gold-luminous text-lg md:text-xl mb-8">Oui, je veux plonger dans cette expérience</p>
                        <a href={BDC} target="_blank" rel="noopener noreferrer" className="btn-gold">
                            Je réserve ma place maintenant <ArrowRight className="w-5 h-5" />
                        </a>
                    </div>
                </div>
            </section>

            <footer className="py-10 px-5 text-center text-xs text-muted bg-bg-main">
                © {new Date().getFullYear()} Gilles Delieuze · L'Agitateur de Particules
            </footer>
        </main>
    );
};

export default EcolePromo;
